import { render } from "./PostLike.vue?vue&type=template&id=035fe7d0&scoped=true"
import script from "./PostLike.vue?vue&type=script&lang=js"
export * from "./PostLike.vue?vue&type=script&lang=js"

import "./PostLike.vue?vue&type=style&index=0&id=035fe7d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035fe7d0"]])

export default __exports__